export const FUNNEL_SESSION_STORAGE_KEY = 'printen_funnel_session_id';

type FunnelConsent = { analytics?: boolean } | null | undefined;
type SessionStorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export function normalizeFunnelSessionId(value: unknown) {
  const normalized = typeof value === 'string' ? value.trim().toLowerCase() : '';
  return /^fs_[a-f0-9]{32}$/.test(normalized) ? normalized : undefined;
}

function randomFunnelSessionId() {
  const uuid = globalThis.crypto?.randomUUID?.().replace(/-/g, '');
  return normalizeFunnelSessionId(uuid ? `fs_${uuid}` : undefined);
}

/**
 * Session-scoped CRO identifier. It is random, contains no customer/account
 * data, and exists only while analytics consent is active. Withdrawal removes
 * it immediately; blocked storage fails closed instead of emitting unstable IDs.
 */
export function getConsentAwareFunnelSessionId(
  storage: SessionStorageLike | null | undefined,
  consent: FunnelConsent,
  createId: () => string | undefined = randomFunnelSessionId,
) {
  if (!storage) return undefined;
  if (consent?.analytics !== true) {
    try {
      storage.removeItem(FUNNEL_SESSION_STORAGE_KEY);
    } catch {
      // Storage can be blocked. There is then no identifier to use or retain.
    }
    return undefined;
  }

  try {
    const existing = normalizeFunnelSessionId(storage.getItem(FUNNEL_SESSION_STORAGE_KEY));
    if (existing) return existing;
    const created = normalizeFunnelSessionId(createId());
    if (!created) return undefined;
    storage.setItem(FUNNEL_SESSION_STORAGE_KEY, created);
    return created;
  } catch {
    return undefined;
  }
}

export function consentedFunnelSessionId(value: unknown, consent: FunnelConsent) {
  return consent?.analytics === true ? normalizeFunnelSessionId(value) : undefined;
}
